<template>
    <modal
        :deleteAction="odbModel._id ?  deleteAction : false "
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :actionButtons="!hideForm"
        size="full"
        :closeButton="hideForm"
        @shown="shown() "
    >
        <template slot="modal-header">
            <span></span>
        </template>

        <ul class="nav nav-tabs mb-5">
            <li class="nav-item">
                <a
                    href="#"
                    @click.prevent="tab ='general'"
                    class="nav-link"
                    :class="{active:tab == 'general'}"
                >{{$t('Objectivly')}}</a>
            </li>
            <li class="nav-item">
                <a
                    href="#"
                    @click.prevent="tab ='diagnosis'"
                    class="nav-link"
                    :class="{active:tab == 'diagnosis'}"
                >{{$t('Diagnoses')}}</a>
            </li>
        </ul>
        <div style="max-height:75vh; overflow-y:auto">
            <div v-if="tab =='general'">
                <div class="row">
                    <div class="col-8 col-md-8">
                        <b-form-group :label="$t('Label')">
                            <b-form-input v-model="odbModel.label" :placeholder="$t('Ex.: Caries')"></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <b-form-group :label="$t('Code')">
                            <b-form-input v-model="odbModel.code" :placeholder="$t('Ex.: A001')"></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-3">
                        <b-form-group :label="$t('Multiple')">
                            <b-form-checkbox v-model="odbModel.multiple"></b-form-checkbox>
                        </b-form-group>
                    </div>-->
                    <div class="col-3">
                        <b-form-group :label="$t('Language')">
                            <b-form-select v-model="odbModel.language" :options="languages"></b-form-select>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col h4">{{$t('Options')}}</div>
                </div>
                <div class="row align-items-center mb-2" v-for="(field, index) in odbModel.fields" :key="index">
                    <div class="col-6">
                        <b-form-input v-model="field.value"></b-form-input>
                    </div>
                    <div class="col">
                        <button class="btn btn-white mr-2" @click="add(index)">
                            <i class="fe fe-plus"></i>
                        </button>
                        <button class="btn btn-white" v-if="index>0" @click="remove(index)">
                            <i class="fe fe-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="tab =='diagnosis'">
                <div class="row align-items-center">
                    <div class="col-12" v-for="(item, index) in odbModel.icd" :key="index">
                        <div class="card mb-1">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        {{item.label}}
                                        <br />
                                        <strong>{{item.code}}</strong>
                                    </div>
                                    <div class="col"></div>

                                    <div class="col-4">
                                        <b-form-select v-model="item.value" v-if="!odbModel.multiple">
                                            <option
                                                v-for="(item, index) in odbModel.fields"
                                                :key="index"
                                                :value="item.value"
                                            >{{item.value}}</option>
                                        </b-form-select>
                                        <!-- <b-form-checkbox-group v-model="item.value">
                                            <b-form-checkbox
                                                v-for="(field, index) in odbModel.fields"
                                                :key="index"
                                                :value="field.value"
                                                style="display:block"
                                            >{{field.value}}</b-form-checkbox>
                                        </b-form-checkbox-group>-->
                                    </div>
                                    <div class="col-auto">
                                        <button class="btn btn-white btn-sm mr-1" @click="removeDiangosis(index)">
                                            <i class="fe fe-x"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-white" @click="openModal({ id: 'ICDModal' });">
                            <i class="fe fe-activity"></i>
                            {{$t('Select diagnosis')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <i-c-d-modal id="ICDModal" :useAction="use"></i-c-d-modal>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import ICDModal from '@/components/ICD10/ICDModal.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'

export default {
    name: 'odb-modal',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
        ICDModal,
    },
    data() {
        return {
            tab: 'general',
            loading: false,
            hideForm: false,
            objectivelyDiagnosis: {},
            languages: [
                { text: 'Russian', value: 'russian' },
                { text: 'English', value: 'english' },
            ],
            odbModel: {
                language: 'english'
            },
            title: 'Objectively DB',

        }
    },
    computed: {
        ...mapState('odb', { icdLoading: 'isFindPending' }),
        ...mapGetters('odb', { findIcdInStore: 'find' }),

        idc() {
            return this.findIcdInStore().data;
        },
    },
    mounted() {

        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
        return this.find({ query: {} }).data;
    },
    methods: {
        ...mapActions('odb', { find: 'find', create: 'create', patch: 'patch', removeOdb: 'remove' }),
        // ...mapActions('diagnose-objectively', ['create', 'patch', 'find', 'get']),

        deleteAction() {
            this.removeOdb(this.odbModel._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been removed')
                });
            });
        },

        save() {

            let promise, successMessage;
            // this.odbModel.icd = this.odbModel.icd.map(item => {
            //     return item._id;
            // });


            if (this.odbModel._id) {
                promise = this.patch([this.odbModel._id, this.odbModel]);
                successMessage = this.$t('Item has been saved');
            } else {
                promise = this.create(this.odbModel);
                successMessage = this.$t('Item has been created');
            }

            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);

                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },

        shown() {
            /* Switch back to the first tab */
            this.odbModel = this.data;
            if (!this.data.icd) {
                // this.odbModel.icd = [];
                this.$set(this.odbModel, 'icd', []);
            }

            if (!this.data.fields) {
                // this.odbModel.fields = [{}];
                this.$set(this.odbModel, 'fields', [{}]);

            }


        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        },
        removeDiangosis(index) {
            this.odbModel.icd.splice(index, 1);
        },
        use(item) {
            item.value = [];
            this.odbModel.icd.push(item);
        },

        add(idx) {
            this.odbModel.fields.splice(idx + 1, 0, {});
        },
        remove(idx) {
            this.odbModel.fields.splice(idx, 1);
        },

    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
